class FostrCartDrawer extends HTMLElement {
  connectedCallback() {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  disconnectedCallback() {

  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.documentElement.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);

    document.documentElement.classList.remove('overflow-hidden');
  }

  setHeaderCartIconAccessibility() {
    const cart_links = Array.from(document.querySelectorAll('#cart-icon-bubble, #cart-icon-bubble-mobile'));

    cart_links.forEach((cart_link) => {
      cart_link.setAttribute('role', 'button');

      cart_link.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cart_link);
      });

      cart_link.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cart_link);
        }
      });
    });
  }

  renderContents(parsedState) {
    const cartDrawerItems = this.querySelector('fostr-cart-drawer-items');
    cartDrawerItems.renderContents(parsedState);

    this.open();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('fostr-cart-drawer', FostrCartDrawer);

class FostrCartDrawerItems extends FostrCartItems {
  getSectionsToRender() {
    return [
      {
        name: 'header',
        id: 'shopify-section-header',
        selectors: [
          '#cart-icon-bubble',
          '#cart-icon-bubble-mobile'
        ]
      },
      {
        name: 'fostr-cart-drawer',
        id: 'shopify-section-fostr-cart-drawer',
        selectors: [
          'fostr-cart-drawer-items',
        ]
      },
    ];
  }
}

customElements.define('fostr-cart-drawer-items', FostrCartDrawerItems);